module.exports = __webpack_public_path__ + "static/img/news01_img.6a5814c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/news01_img.jpg
// module id = o27s
// module chunks = 1